import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Media from "react-media";
import { CountBoxReusableSeatingComponent } from "../../../reusableComponents/IconBoxReusable/IconBoxReusableComponent";

export const SeatingDashboardRight = (props) => {
  //state
  const [showCount, setShowCount] = useState(false);
  const handleSHowCount = () => {
    setShowCount({
      showCount: !showCount.showCount,
    });
  };
  return (
    <React.Fragment>
      <Media query="(max-width: 991px)">
        <>
          <div className="w-100">
            <hr className="mb-0" />
          </div>
          {/* <div className="col-12 seating-right-side-boxcount  mt-3">
            <div className="mobile py-2">
              <h4 className="f12-700">
                No. of request {props.totalCount ? props.totalCount : "00"}
              </h4>

              <Button
                variant="link"
                className="f10-500 text-blue"
                onClick={handleSHowCount}
              >
                {showCount.showCount ? "Hide Details" : "View Details"}
              </Button>
            </div>
            {showCount.showCount && (
              <div className="row py-3">
                <div className="col-3 text-center px-1">
                  <CountBoxReusableSeatingComponent
                    classSection="box-colorgray"
                    count={props.totalCount ? props.totalCount : "00"}
                    iconText="Total Open"
                    iconTextStyle="colorgray"
                  />
                </div>
                <div className="col-3 text-center px-1">
                  <CountBoxReusableSeatingComponent
                    classSection="box-colororange"
                    count={props.pendingCount ? props.pendingCount : "00"}
                    iconText="Pending"
                    iconTextStyle="colororange"
                  />
                </div>
                <div className="col-3 text-center px-1">
                  <CountBoxReusableSeatingComponent
                    classSection="box-colordark_green"
                    count={props.walkinCount ? props.walkinCount : "00"}
                    iconText="Walk-In/WaitList"
                    iconTextStyle="colordark_green"
                  />
                </div>
                <div className="col-3 text-center px-1">
                  <CountBoxReusableSeatingComponent
                    classSection="box-colorlight_green"
                    count={
                      props.reservationCount ? props.reservationCount : "00"
                    }
                    iconText="Reservations"
                    iconTextStyle="colorlight_green"
                  />
                </div>
              </div>
            )}
          </div> */}
        </>
      </Media>
      <Media query="(min-width: 992px)">
        <>
          <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 offset-md-4 offset-lg-4 offset-xl-4 seating-right-side-boxcount">
            <h4 className="seating-right-side-boxcount-head">No. of request</h4>
            <div className="row">
              <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center">
                <CountBoxReusableSeatingComponent
                  classSection="box-colorgray"
                  count={props.totalCount ? props.totalCount : "00"}
                  iconText="Total Open"
                  iconTextStyle="colorgray"
                />
              </div>
              <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center">
                <CountBoxReusableSeatingComponent
                  classSection="box-colororange"
                  count={props.pendingCount ? props.pendingCount : "00"}
                  iconText="Pending"
                  iconTextStyle="colororange"
                />
              </div>
              <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center">
                <CountBoxReusableSeatingComponent
                  classSection="box-colordark_green"
                  count={props.walkinCount ? props.walkinCount : "00"}
                  iconText="Walk-In/WaitList"
                  iconTextStyle="colordark_green"
                />
              </div>
              <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center">
                <CountBoxReusableSeatingComponent
                  classSection="box-colorlight_green"
                  count={props.reservationCount ? props.reservationCount : "00"}
                  iconText="Reservations"
                  iconTextStyle="colorlight_green"
                />
              </div>
              {/* <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center">
            <CountBoxReusableSeatingComponent
              classSection={
                props.selectedPage === 1
                  ? "seating-dashboard-reusable-button seating-dashboard-reusable-button-active"
                  : "seating-dashboard-reusable-button"
              }
              imageStyle="inside-image-button-seat"
              src={props.selectedPage === 1 ? seatingWhite : seatingDark}
              iconText="Seating"
              iconTextStyle={
                props.selectedPage === 1
                  ? "icon-bottom-text icon-bottom-text-active"
                  : "icon-bottom-text"
              }
              link="/seatingdashboard"
              bottomLine={
                props.selectedPage === 1 ? "bottom-box-line" : null
              }
            />
          </div>
          <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 p-0 text-center">
            <CountBoxReusableSeatingComponent
              classSection={
                props.selectedPage === 3
                  ? "seating-dashboard-reusable-button seating-dashboard-reusable-button-active"
                  : "seating-dashboard-reusable-button"
              }
              imageStyle="inside-image-button"
              src={
                props.selectedPage === 3
                  ? reservationWhite
                  : reservationDark
              }
              iconText="Reservations"
              iconTextStyle={
                props.selectedPage === 3
                  ? "icon-bottom-text icon-bottom-text-active"
                  : "icon-bottom-text"
              }
              link="/reservationdashboard"
              bedgeClass="badge custom-icon-button-badge cutom-badge-position-reservation"
              displayNotification={false}
              // notificationCount="24"
              bottomLine={
                props.selectedPage === 3 ? "bottom-box-line" : null
              }
            />
          </div>
          <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center">
            <CountBoxReusableSeatingComponent
              classSection={
                props.selectedPage === 4
                  ? "seating-dashboard-reusable-button seating-dashboard-reusable-button-active"
                  : "seating-dashboard-reusable-button"
              }
              imageStyle="inside-image-button"
              src={props.selectedPage === 4 ? historyWhite : historyDark}
              iconText="History"
              iconTextStyle={
                props.selectedPage === 4
                  ? "icon-bottom-text icon-bottom-text-active"
                  : "icon-bottom-text"
              }
              link="/historydashboard"
              bottomLine={
                props.selectedPage === 4 ? "bottom-box-line" : null
              }
            />
          </div> */}
            </div>
            <div className="col-12 p-0">
              <hr className="mobile-device-line" />
            </div>
          </div>
        </>
      </Media>
    </React.Fragment>
  );
};

// import React, { Component } from "react";
// import Image from "react-bootstrap/Image";
// import { DropDownButton } from "../../../reusableComponents/dropDownButtonReusable/DropDownButton";
// import SeatingStatus from "../../../reusableComponents/allPopupReusable/tableNumberPopup/SeatingStatus";

// export class SeatingDashboardRight extends Component {
//   constructor(props) {
//     super(props);
//     state = {
//       // status: "All",
//       // defaultWaitTime: "05-10",
//       // pax: "All",
//     };
//   }

//   render() {
//     return (
//       <React.Fragment>
//         <div className="row right-side-seating">
//           {/* <div className="col-3">
//             <SeatingStatus />
//           </div>
//           <div className="col-3">
//             <DropDownButton
//               dropDownCss="main-dropdown-section"
//               headingText="Seating Status"
//               divClass="inside-div-other"
//               insideText={state.defaultWaitTime}
//               displayDropDown=""
//             />
//           </div>
//           <div className="col-3">
//             <DropDownButton
//               dropDownCss="main-dropdown-section"
//               headingText="PAX"
//               divClass="inside-div"
//               insideText={state.pax}
//               displayDropDown=""
//             />
//           </div>
//           <div className="col-3 d-flex align-items-center justify-content-center">
//             <Image
//               fluid
//               src={require("../../../../assets/images/AuthImages/checked.png")}
//               alt="Checked"
//               title="All Record"
//               className="checked-images"
//             />
//           </div> */}
//         </div>
//       </React.Fragment>
//     );
//   }
// }

// export default SeatingDashboardRight;
